import i18n  from "i18next";
import { initReactI18next } from 'react-i18next'
import backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
      backend:{
          //translation file path
          loadPath: "/assets/i18n/{{ns}}/{{lng}}.json",
      },
      fallbackLng: "es",
      debug: false,

      ns: ["common", "home", "profile"],

      interpolation:{
          espaceValue: false,
          formatSeparator: ",",
      },

      react: {
          useSuspense: true 
              }

  })